import { render } from "./ringingChoose.vue?vue&type=template&id=60594742&scoped=true"
import script from "./ringingChoose.vue?vue&type=script&lang=js"
export * from "./ringingChoose.vue?vue&type=script&lang=js"

import "./ringingChoose.vue?vue&type=style&index=0&id=60594742&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60594742"]])

export default __exports__